import { toast } from 'react-toastify';

import { NATIVE_TOKENS, routerAbi, TOKEN_BY_ADDRESS, WRAPPED_NATIVE_TOKENS } from 'consts';
import { TokenInfo } from 'types';
import { bn } from 'utils/BigNumber';
import { cutTokenSymbol } from 'utils/helpers';
import { decodeEventLog, TransactionReceipt } from 'viem';

const getSuccessMessage = (
  amountIn: string,
  tokenIn: TokenInfo,
  amountOut: string,
  tokenOut: TokenInfo
) =>
  `You swapped ${bn(amountIn).toView(tokenIn.decimals)} ${cutTokenSymbol(tokenIn.symbol)} to ${bn(amountOut).toView(tokenOut.decimals)} ${cutTokenSymbol(tokenOut.symbol)}`;

export const parseLogs = (receipt: TransactionReceipt, value: string, chainId: number) => {
  try {
    const lastLog = receipt.logs[receipt.logs.length - 1];
    if (!lastLog) return;
    const decodedLog = decodeEventLog({
      abi: routerAbi,
      data: lastLog.data,
      topics: lastLog.topics,
    });
    const { args } = decodedLog as any;

    let tokenIn = TOKEN_BY_ADDRESS[chainId][args.from.toLowerCase()];
    let tokenOut = TOKEN_BY_ADDRESS[chainId][args.to[0].toLowerCase()];
    if (!tokenIn || !tokenOut) return;
    if (value !== '0') {
      tokenIn = NATIVE_TOKENS[chainId];
    }
    if (tokenOut === WRAPPED_NATIVE_TOKENS[chainId]) {
      tokenOut = NATIVE_TOKENS[chainId];
    }
    const amountIn = args.amountIn.toString();
    const amountOut = args.amountOut[0].toString();

    return getSuccessMessage(amountIn, tokenIn, amountOut, tokenOut);
  } catch (err) {
    return '';
  }
};

const STOP_ERRORS = [
  'ERC20: insufficient allowance',
  'BEP20: transfer amount exceeds allowance',
  'Allowance amount exceeds balance',
  'WOWMAX: Insufficient output amount',
  'Execution reverted with reason: K',
];

export const stopSwapByGasError = (err: any) => {
  if (STOP_ERRORS.some((text) => err.shortMessage?.includes(text))) {
    toast.error(err.shortMessage);
    return true;
  }
  return false;
};
